import { render, staticRenderFns } from "./studentIdentity.vue?vue&type=template&id=6e612e54&scoped=true&"
import script from "./studentIdentity.vue?vue&type=script&lang=js&"
export * from "./studentIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e612e54",
  null
  
)

export default component.exports